interface User {
  id: string;
  name: string;
  starRating: number;
}

type AllTimeStarsProps = {
  users: User[];
};

const AllTimeStars = ({ users }: AllTimeStarsProps) => {
  return (
    <div className="all-time-stars">
      <h3>All time Stars</h3>
      <p className="text-xs opacity-70 mb-2">Based on lifetime points</p>
      <ul>
        {users?.map((user) => {
          return (
            <li key={user.id}>
              <span>{user.name}</span>
              <span>{user.starRating}⭐</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
export default AllTimeStars;
